// Foundations
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';

// Services
import { AnalyticsService } from 'src/app/services/analytics.service';

@Component({
  selector: 'app-welcome-page',
  templateUrl: './welcome-page.component.html',
  styleUrls: ['./welcome-page.component.scss']
})
export class WelcomePageComponent implements OnInit {

  constructor(
    private router: Router,
    private _analytics: AnalyticsService,
    private titleService: Title
  ) {
    this.titleService.setTitle('Client Portal - Welcome');
  }

  ngOnInit(): void {
    this._analytics.logScreen('welcomePage');
  }

  navigateToRegisterPage() {
    this._analytics.logButtonTap('welcome_continue');
    this.router.navigate(['/register']);
  }

  navigateToSignInPage() {
    this._analytics.logLinkTap('welcome_signIn');
  }

}
